import styled from '@emotion/styled';
import AttentionIcon from 'ui/images/attention.svg';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    max-height: 80vh;
    padding: 40px;
`;

const Descriptions = styled.div`
    display: flex;
    gap: 5px;
    align-items: center;
    justify-content: center;
    padding-bottom: 5px;

    img {
        width: 20px;
        height: 20px;
    }
`;

const Desc = styled.p`
    white-space: pre-line;
    font-weight: var(--font-bold);
`;

const Buttons = styled.div`
    display: flex;
    gap: 10px;
    width: 100%;
    max-width: 500px;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
`;

const SubmitButton = styled.button`
    width: 80%;
    max-width: 200px;
    background-color: var(--warn);
    color: var(--white);
    font-size: var(--font-large);
    font-weight: var(--font-bold);
    padding: 15px;
    border-radius: 25px;
    cursor: pointer;
    border: none;
    outline: none;
`;

const CancelButton = styled.button`
    width: 80%;
    max-width: 200px;
    background-color: #808080;
    color: var(--white);
    font-size: var(--font-large);
    font-weight: var(--font-bold);
    padding: 15px;
    border-radius: 25px;
    cursor: pointer;
    border: none;
    outline: none;
    &:hover {
        opacity: 0.9;
    }
    &:active {
        transform: scale(0.98);
    }
`;

const Attention = styled.div`
    font-size: var(--font-default);
    color: red;
    margin-top: 5px;
    line-height: 1.5;
`;

interface Props {
    onSubmit: () => void;
    onCancel: () => void;
    loading: boolean;
}

/**
 * 売り手・買い手企業が案件を掲載終了にするモーダル
 */
export const CloseCompanyInfo: React.FC<Props> = ({ onSubmit, onCancel, loading }) => {
    return (
        <Wrapper>
            <Descriptions>
                <img src={AttentionIcon} alt="警告アイコン" />
                <Desc>案件の公開を停止します</Desc>
            </Descriptions>
            <Attention>
                ※案件の公開を停止すると新しいオファーが届かなくなります。
                <br />
                ※一度非公開化しても「案件の公開を再開する」ボタンを押すと再度仲介会社へ案件が公開され新しいオファーが届く可能性があります。
            </Attention>
            <Buttons>
                <CancelButton onClick={onCancel}>キャンセル</CancelButton>
                <SubmitButton disabled={loading} onClick={onSubmit}>
                    非公開にする
                </SubmitButton>
            </Buttons>
        </Wrapper>
    );
};
